import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const NailsHit = (props) => {
  const data = useStaticQuery(graphql`
    query {
      nailsHit: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/GallerySection/images/nails-hit.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 536, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.nailsHit.childImageSharp.fluid} {...props} />
}

export default NailsHit
